import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const BetaChip = () => {
  const { t } = useTranslation('translation');

  return (
    <Chip
      size="small"
      label={t('donations.beta')}
      sx={{
        height: 22,
        fontSize: 10,
        fontWeight: 700,
        borderRadius: 1,
        color: 'common.white',
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.main} 100%)`,
        letterSpacing: 1.2,
        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
        border: 'none',
        '& .MuiChip-label': {
          px: 1,
          lineHeight: 1,
          position: 'relative',
          top: '-1px',
        },
      }}
    />
  );
};

export default BetaChip;
